/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SuccessResponse_FeatureFlagsResponse_ } from '../models/SuccessResponse_FeatureFlagsResponse_';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SettingsService {
    /**
     * Get Feature Flags
     * v0.12.2 公开 feature flag 通告.
     *
     * 限流 (P1-7): fixed_window 30/60s/IP, fail-open (Redis 挂时放过).
     * response: enable_legacy_employee_import (默认 true, ops .env 改 false 后 frontend
     * 自动隐藏「补录历史员工」按钮).
     * @returns SuccessResponse_FeatureFlagsResponse_ Successful Response
     * @throws ApiError
     */
    public static getFeatureFlagsApiV1SettingsFeaturesGet({
        annotatedRequest,
    }: {
        annotatedRequest?: null,
    }): CancelablePromise<SuccessResponse_FeatureFlagsResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/settings/features',
            query: {
                '_annotated_request': annotatedRequest,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
